module.exports = __webpack_public_path__ + "media/images/flags/4x3/aus-dd1760ce4af27818306aebe0355cc6fa.svg";